import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { v1 as uuidv1 } from 'uuid';
import { toast } from 'react-toastify';
import Button from '../forms/Button';
import Select from '../forms/Select';
import TextArea from '../forms/TextArea';
import FileInput from '../forms/FileInput';
import Icon from '../forms/Icon';
import { requestSaveIssue } from '../../actions/issue';
import NewIcon from '../../images/new.png';
import { getLocalizedString, getLocalizedDateTime, getLocalizedName } from '../../localization/LocalizedString';

class ManualIssue extends React.Component {
  constructor(props) {
    super(props);
    this.requestId = uuidv1();
    this.state = {
      images: [],
      selectedServiceId: null,
      selectedTaskId: null,
    };
  }

  onSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    // const task = this.props.tasks.find(task => task.taskId === evt.target.taskId.value)
    const data = {
      requestId: this.requestId,
      destinationId: this.props.destination.id,
      serviceSiteId: this.props.serviceSite.id,

    };

    for (const [key, value] of formData.entries()) {
      if (key === 'taskId' && value) {
        const task = this.props.tasks.find((task) => task.taskId === value);
        data.timestamp = task.totalEndTime;
      }
      data[key] = value;
    }

    data.type = JSON.parse(data.type);

    const { requestSaveIssue, translate } = this.props;
    const { images } = this.state;

    const multiPart = new FormData();
    multiPart.append('issue', JSON.stringify(data));
    if (images && images.length > 0) {
      multiPart.append('image', images[0]);
    }

    requestSaveIssue(multiPart, (e) => {
      console.log(e);
      toast.error(translate('new_task.save_failed'));
    },
    () => this.props.onSaved(),
      // eslint-disable-next-line function-paren-newline
    );
  }

  getServiceOptions() {
    const { currentLanguage } = this.props;
    const { serviceSite: { services = [] } = {} } = this.props;

    return services.map((service) => ({
      value: service.id,
      text: getLocalizedString(service.name, currentLanguage),
    }));
  }

  getTaskOptions() {
    const { currentLanguage } = this.props;
    const { tasks = [] } = this.props;
    return tasks.map((task) => {
      return {
        value: task.taskId,
        text: `${getLocalizedDateTime(new Date(task.totalEndTime), currentLanguage)} ${getLocalizedName(task.service, currentLanguage)}`,
      };
    });
  }

  getTypeOptions() {
    const { currentLanguage } = this.props;
    const { selectedServiceId } = this.state;
    const { serviceSite: { services = [] } = {} } = this.props;

    const selectedService = services.find((service) => (service.id === selectedServiceId));
    const { serviceTemplate: { issueTypes = [] } = {} } = selectedService || {};

    return issueTypes.map((type) => ({
      value: JSON.stringify(type),
      text: getLocalizedString(type, currentLanguage),
    }));
  }

  onImageAdded = (evt) => {
    const { images } = this.state;

    this.setState({
      images: [
        ...images,
        ...evt.target.files,
      ],
    });
  }

  onImageRemoved = (evt) => {
    const { images } = this.state;

    const attachments = images.slice();
    attachments.splice(evt.index, 1);

    this.setState({
      images: attachments,
    });
  }

  onServiceSelected = (evt) => {
    this.setState({
      selectedServiceId: evt.target.value,
      selectedTaskId: null,
    });
  }

  onTaskSelected = (evt) => {
    if (evt.target.value) {
      const task = this.props.tasks.find((task) => task.taskId === evt.target.value);
      this.setState({
        selectedTaskId: evt.target.value,
        selectedServiceId: task.service.id,
      });
    } else {
      this.setState({
        selectedTaskId: null,
        selectedServiceId: null,
      });
    }
  }

  render() {
    const { translate } = this.props;
    const { images } = this.state;
    const selectedService = this.state.selectedServiceId ? this.state.selectedServiceId : '';
    const selectedTask = this.state.selectedTaskId ? this.state.selectedTaskId : '';
    return (
      <form onSubmit={this.onSubmit.bind(this)}>

        <div>
          <div className="row">
            <div className="col-sm-12">
              <h1>{translate('new_issue.title')}</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <Select
                name="taskId"
                data={this.getTaskOptions()}
                placeholder={this.props.translate('new_issue.task_placeholder')}
                onChange={this.onTaskSelected.bind(this)}
                value={selectedTask} />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <Select
                name="serviceId"
                data={this.getServiceOptions()}
                placeholder={this.props.translate('new_issue.service_placeholder')}
                onChange={this.onServiceSelected.bind(this)}
                value={selectedService}
                required />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <Select
                name="type"
                data={this.getTypeOptions()}
                placeholder={this.props.translate('new_issue.type_placeholder')}
                required />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h2>{translate('new_issue.message')}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <TextArea name="description" rows={10} placeholder={translate('new_issue.message_placeholder')} required translate={translate} />
            </div>
          </div>

          { images.length === 0
            && (
            <div className="row">
              <div className="col-sm-12">
                <FileInput className="vertical-middle"
                           multiple={false}
                           onClick={(event) => { event.currentTarget.value = null; }}
                           onChange={this.onImageAdded}
                           accept=".jpg, .jpeg, .png">
                  <Icon src={NewIcon} />
                  <h3 className="primary-color inline-block">{translate('new_issue.instructions_attachment')}</h3>
                </FileInput>
              </div>
            </div>
            )}
          <div className="row">
            <div className="col-sm-12">
              <FileInput.List files={images} onRemove={this.onImageRemoved} />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <Button onClick={this.props.onCancel}>{translate('form.reset')}</Button>
            </div>
            <div className="col-sm-6">
              <Button>{translate('form.submit')}</Button>
            </div>
          </div>
        </div>

      </form>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLanguage = getActiveLanguage(locale);
  return {
    translate: getTranslate(locale),
    currentLanguage: activeLanguage?.code || 'fi',
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestSaveIssue,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManualIssue);
